var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "selectRef", staticClass: "custom-select-wrapper" }, [
    _c(
      "div",
      { staticClass: "custom-select-input", on: { click: _vm.toggleDropdown } },
      [
        _c("div", { staticClass: "custom-select-selected-text" }, [
          _vm._v(_vm._s(_vm.selectedItemsText || _vm.placeholder))
        ]),
        _vm._v(" "),
        _vm.options.length > 1
          ? [
              _vm.showDropdown
                ? _c("font-awesome-icon", { attrs: { icon: "chevron-up" } })
                : _c("font-awesome-icon", { attrs: { icon: "chevron-down" } })
            ]
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.showDropdown
      ? _c(
          "div",
          { staticClass: "custom-select-dropdown" },
          [
            _vm.showAllOption && _vm.options.length > 1
              ? _c(
                  "label",
                  {
                    staticClass: "custom-select-dropdown-item",
                    attrs: { for: "checkbox-all-option" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectAll,
                          expression: "selectAll"
                        }
                      ],
                      staticClass: "tls-input-checkbox",
                      attrs: { type: "checkbox", id: "checkbox-all-option" },
                      domProps: {
                        checked: Array.isArray(_vm.selectAll)
                          ? _vm._i(_vm.selectAll, null) > -1
                          : _vm.selectAll
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.selectAll,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.selectAll = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.selectAll = $$c
                            }
                          },
                          _vm.handleSelectAllChange
                        ]
                      }
                    }),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm._.get(_vm.keywords, "all")) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.options, function(item, index) {
              return _c(
                "label",
                {
                  key: index,
                  staticClass: "custom-select-dropdown-item",
                  attrs: { for: "checkbox-" + item.value + "-" + index }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected[index],
                        expression: "selected[index]"
                      }
                    ],
                    staticClass: "tls-input-checkbox",
                    attrs: {
                      type: "checkbox",
                      id: "checkbox-" + item.value + "-" + index
                    },
                    domProps: {
                      checked: Array.isArray(_vm.selected[index])
                        ? _vm._i(_vm.selected[index], null) > -1
                        : _vm.selected[index]
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.selected[index],
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.selected, index, $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.selected,
                                  index,
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.selected, index, $$c)
                          }
                        },
                        _vm.updateSelection
                      ]
                    }
                  }),
                  _vm._v("\n      " + _vm._s(item.title) + "\n    ")
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }